import s from './LinkedDeals.scss'
import { UncontrolledTooltip } from 'reactstrap'
import { FaInfoCircle, FaUnlink } from 'react-icons/fa'

const getClientsNames = clients => {
  return clients.map(client => client.company.name).join(', ')
}

const LinkedDeals = ({ parent, kids, related, readOnly = false, unlinkDeal }) => {
  if (!parent && !kids.length && !related.length)
    return <p>Currently there are no linked opportunities</p>

  return (
    <div className={s.container}>
      {parent && (
        <div className={s.section}>
          <p className={s.title}>
            Parent Opportunity{' '}
            {!readOnly && (
              <>
                <FaInfoCircle id="parent" />
                <UncontrolledTooltip placement="top" target="parent">
                  This is the parent of the current opportunity
                </UncontrolledTooltip>
              </>
            )}
          </p>
          {!readOnly && (
            <FaUnlink
              title="Unlink"
              className={s.unlink}
              onClick={() => unlinkDeal(parent.id, 'parent')}
            />
          )}
          <a target="_blank" href={`/opportunities/${parent.id}`} rel="noreferrer">
            {parent.name}{' '}
          </a>
          - {getClientsNames(parent.clients)} - {parent.status.name} - {parent.manager.firstName}{' '}
          {parent.manager.lastName}
        </div>
      )}
      {kids.length > 0 && (
        <div className={s.section}>
          <p className={s.title}>
            Child Opportunities{' '}
            {!readOnly && (
              <>
                <FaInfoCircle id="child" />
                <UncontrolledTooltip placement="top" target="child">
                  If current opportunity has children, or sub-opportunities, they are listed below
                </UncontrolledTooltip>
              </>
            )}
          </p>
          {kids.map(k => (
            <div className={s.item} key={k.id}>
              {!readOnly && (
                <FaUnlink
                  title="Unlink"
                  className={s.unlink}
                  onClick={() => unlinkDeal(k.id, 'child')}
                />
              )}
              <a target="_blank" href={`/opportunities/${k.id}`} rel="noreferrer">
                {k.name}{' '}
              </a>
              - {getClientsNames(k.clients)} - {k.status.name} - {k.manager.firstName}{' '}
              {k.manager.lastName}
            </div>
          ))}
        </div>
      )}
      {related.length > 0 && (
        <div className={s.section}>
          <p className={s.title}>
            Related Opportunities{' '}
            {!readOnly && (
              <>
                <FaInfoCircle id="related" />
                <UncontrolledTooltip placement="top" target="related">
                  Opportunities with the same parent as the current one. Sister Opportunities.
                </UncontrolledTooltip>
              </>
            )}
          </p>
          {related.map(k => (
            <div className={s.item} key={k.id}>
              {!readOnly && (
                <FaUnlink
                  title="Unlink"
                  className={s.unlink}
                  onClick={() => unlinkDeal(k.id, 'related')}
                />
              )}
              <a target="_blank" href={`/opportunities/${k.id}`} rel="noreferrer">
                {k.name}{' '}
              </a>
              - {getClientsNames(k.clients)} - {k.status.name} - {k.manager.firstName}{' '}
              {k.manager.lastName}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default LinkedDeals
